import NodeViewConstructorArgs from '../constructor/NodeViewConstructorArgs';
import AbstractNodeView from './AbstractNodeView';
import * as d3 from 'd3';
import condition from '../assets/condition.svg';
import WorkFlowView from '../view/WorkFlowView';
import View from '../view/View';
import { Syntax } from '@trlogic/ui-pack';
import { NodeType } from '../../../../domain/collection/rule/FlowDomains';
import conditionDisable from '../assets/condition_disable.svg';

class ConditionNodeView extends AbstractNodeView {
  public constructor(args: NodeViewConstructorArgs) {
    super(args);
  }

  public initialize(): void {
    this.render();
  }

  public render(): void {
    let node: any;

    if (this.shadow) {
      node = d3.select((this.workFlowView as WorkFlowView).getParent()).append('svg');
    } else {
      node = d3
        .select((this.workFlowView as WorkFlowView).getNode())
        .select('#workflow-container-group')
        .append('g');
    }

    const nodeEnter = node
      .attr('id', this.el.substring(1, this.el.length))
      .attr('type', 'Condition')
      .style('position', 'absolute')
      .style('pointer-events', 'auto')
      .style('cursor', 'pointer')
      .style('width', '50px')
      .style('height', '50px');

    nodeEnter
      .append('rect')
      .attr('width', 50)
      .attr('height', 50)
      .attr('rx', 3)
      .style('stroke', '#8F00FF')
      .attr('stroke-width', 1)
      .style('fill', 'white')
      .style('stroke-dasharray', '0');

    nodeEnter
      .append('svg:image')
      .attr('xlink:href', condition)
      .attr('width', 20)
      .attr('height', 20)
      .attr('x', 50 / 2 - 10)
      .attr('y', 50 / 2 - 10);

    nodeEnter
      .append('text')
      .attr('x', 50 / 2 + 40)
      .attr('y', 50 / 2 - 2)
      .attr('dy', '.35em')
      .style('fill', '#4F4F4F')
      .text(this.getModel<any>().value.name);

    const status = this.getModel<any>().value.status;
    if (status === false) {
      d3.selectAll(this.getNode()).select('rect').style('stroke', '#bdbdbd').style('stroke-dasharray', '6');
      d3.selectAll(this.getNode())
        .select('image')
        .attr('xlink:href', conditionDisable)
        .attr('width', 20)
        .attr('height', 20)
        .style('fill', 'red')
        .attr('x', 50 / 2 - 10)
        .attr('y', 50 / 2 - 10);
      d3.selectAll(this.getNode()).select('text').style('fill', '#bdbdbd');
    }
  }

  public socketHighlight(type?: NodeType) {}

  public socketUnHighlight(): void {}

  protected preSwap(target: View<Syntax>): boolean {
    switch (target.constructor) {
      case ConditionNodeView:
        return true;
      default:
        return false;
    }
  }

  public setModel(model: Syntax) {
    d3.select(this.el)
      .select('text')
      .text((model.value as any).name);
  }
}

export default ConditionNodeView;
